export default __webpack_public_path__ + "static/media/apache_airflow.775d705d.svg";